var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOkSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#32A538",
  fillRule: "evenodd",
  d: "M0 9.857C0 4.425 4.425 0 9.857 0c5.433 0 9.857 4.425 9.857 9.857 0 5.433-4.424 9.857-9.857 9.857S0 15.29 0 9.857m2.19 0c0 4.228 3.44 7.667 7.667 7.667s7.667-3.439 7.667-7.667S14.085 2.19 9.857 2.19 2.19 5.63 2.19 9.857m4.042-1.204 2.53 2.523 4.72-4.733L14.7 7.667l-5.937 5.936-3.746-3.746z",
  clipRule: "evenodd"
})));
export default SvgOkSmall;